import { useContext, useEffect, useState } from "react";
import { MenuItem, TextField } from '@mui/material';
import BuilderContext from '../../../../store/BuilderContext';
import AuthContext from "../../../../store/AuthContext";

const FontSize = (props) => {
  const { blockId, screenType } = props;
  const builderCtx = useContext(BuilderContext);
  const authCtx = useContext(AuthContext);
  const { contentBlocks, updateContentBlocks, currentContentBlock, updateCurrentBlock } = builderCtx;


  const getCurrentBlockStyles = () => {
    switch ( screenType ) {
      case "mobile" :
        return currentContentBlock?.mobileStyling;
      break;
      case "horizontal":
        return currentContentBlock?.horizontalStyling;
      break;
      case "vertical":
        return currentContentBlock?.verticalStyling;
      break;
      default:
        return currentContentBlock?.styling;
      break;
    }
  } 

  const fontSizeUnitValue = (type,size) => {
    const sizeString = String(size);

    const value = parseFloat(sizeString);
    const unit = sizeString.replace(value, '').trim();
    
    if ( type === 'value' ) return value;
    
    return unit;

  };

  const currentBlockStyles = getCurrentBlockStyles()
  const currentFontSize = currentBlockStyles?.fontSize;

  
  const [fontSize, setFontSize] = useState(fontSizeUnitValue("value",currentFontSize) || "16");
  const [unit, setUnit] = useState(fontSizeUnitValue("unit",currentFontSize)  || "px");


  const [onChangeFlag, setOnChangeFlag] = useState(false);

  const units = [
    { value: 'px', label: 'px' },
    { value: 'rem', label: 'rem' },
    { value: 'em', label: 'em' },
    { value: '%', label: '%' },
  ];

  const handleUnitChange = (e) => {
    setOnChangeFlag(true);
    setUnit(e.target.value);
  };

  const handleFontSizeChange = (e) => {
    setOnChangeFlag(true);
    setFontSize(e.target.value);
  };

  const updateFontSize = (fontSizeValue) => {
    const payload = {
      id: blockId,
      value: fontSizeValue + unit,
      screenType: props?.screenType
    };

    fetch(process.env.REACT_APP_API_URI + '/v3/admin/assessment/styling/fontSize', {
      method: 'PUT',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authCtx.token },
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          console.log("Updating font size payload", payload);
        }
      }).catch((err) => {
        console.error("Failed to update font size...", err);
      });
  };

  useEffect(() => {
    if (onChangeFlag) {
      updateFontSize(fontSize);
    }
  }, [fontSize, unit, onChangeFlag]);

  useEffect(() => {
    const timer = setTimeout(() => {
      // updateContentBlocks(contentBlocks?.map(block => {
      //   if (block.id === blockId) {
      //     return {
      //       ...block,
      //       styling: {
      //         ...block.styling,
      //         fontSize: fontSize + unit
      //       }
      //     };
      //   }
      //   return block;
      // }));
      switch ( screenType ) {
        case "mobile" : 
          updateContentBlocks(contentBlocks?.map(block => {
            if (block.id === blockId) {
              return {
                ...block,
                mobileStyling: {
                  ...block.mobileStyling,
                  fontSize: fontSize + unit
                }
              };
            }
            return block;
          }));
        break;
        case "horizontal" :
          updateContentBlocks(contentBlocks?.map(block => {
            if (block.id === blockId) {
              return {
                ...block,
                horizontalStyling: {
                  ...block.horizontalStyling,
                  fontSize: fontSize + unit
                }
              };
            }
            return block;
          }));
        break;
        case "vertical" :
          updateContentBlocks(contentBlocks?.map(block => {
            if (block.id === blockId) {
              return {
                ...block,
                verticalStyling: {
                  ...block.verticalStyling,
                  fontSize: fontSize + unit
                }
              };
            }
            return block;
          }));
        break;
        default:
          updateContentBlocks(contentBlocks?.map(block => {
            if (block.id === blockId) {
              return {
                ...block,
                styling: {
                  ...block.styling,
                  fontSize: fontSize + unit
                }
              };
            }
            return block;
          }));
        break;
      }
      setOnChangeFlag(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [blockId, fontSize, unit]);

  return (
    <div className="font-size tool">
      {props.deleteModal}
      <TextField id="font-size-number" className="font-size-input styling-input" type="number" variant="filled"
        InputLabelProps={{ shrink: true }} placeholder={currentContentBlock?.styling?.fontSize} value={fontSize} onChange={handleFontSizeChange} />

      <TextField className="font-size-unit styling-select" select variant="standard" InputProps={{ disableUnderline: true }} value={unit} onChange={handleUnitChange}>
        {units.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
}

export default FontSize;
